import { L10N } from '../misc/L10N';
export function l(str : "box user");
export function l(str : "filetype_box user");
export function l(str : "html");
export function l(str : "filetype_html");
export function l(str : "wiki");
export function l(str : "filetype_wiki");
export function l(str : "webscraperwebpage");
export function l(str : "filetype_webscraperwebpage");
export function l(str : "image");
export function l(str : "filetype_image");
export function l(str : "folder");
export function l(str : "filetype_folder");
export function l(str : "txt");
export function l(str : "filetype_txt");
export function l(str : "zip");
export function l(str : "filetype_zip");
export function l(str : "olefile");
export function l(str : "filetype_olefile");
export function l(str : "gmailmessage");
export function l(str : "filetype_gmailmessage");
export function l(str : "pdf");
export function l(str : "filetype_pdf");
export function l(str : "swf");
export function l(str : "filetype_swf");
export function l(str : "xml");
export function l(str : "filetype_xml");
export function l(str : "vsd");
export function l(str : "filetype_vsd");
export function l(str : "svg");
export function l(str : "filetype_svg");
export function l(str : "svm");
export function l(str : "filetype_svm");
export function l(str : "rssitem");
export function l(str : "filetype_rssitem");
export function l(str : "doc");
export function l(str : "filetype_doc");
export function l(str : "docx");
export function l(str : "filetype_docx");
export function l(str : "xls");
export function l(str : "filetype_xls");
export function l(str : "ppt");
export function l(str : "filetype_ppt");
export function l(str : "video");
export function l(str : "filetype_video");
export function l(str : "youtube");
export function l(str : "filetype_youtube");
export function l(str : "saleforceitem");
export function l(str : "filetype_saleforceitem");
export function l(str : "dynamicscrmitem");
export function l(str : "filetype_dynamicscrmitem");
export function l(str : "salesforceitem");
export function l(str : "filetype_salesforceitem");
export function l(str : "odt");
export function l(str : "filetype_odt");
export function l(str : "box");
export function l(str : "filetype_box");
export function l(str : "jiraissue");
export function l(str : "filetype_jiraissue");
export function l(str : "cfpage");
export function l(str : "filetype_cfpage");
export function l(str : "cfcomment");
export function l(str : "filetype_cfcomment");
export function l(str : "cfspace");
export function l(str : "filetype_cfspace");
export function l(str : "cfblogentry");
export function l(str : "filetype_cfblogentry");
export function l(str : "confluencespace");
export function l(str : "filetype_confluencespace");
export function l(str : "exchangemessage");
export function l(str : "filetype_exchangemessage");
export function l(str : "exchangeappointment");
export function l(str : "filetype_exchangeappointment");
export function l(str : "exchangenote");
export function l(str : "filetype_exchangenote");
export function l(str : "exchangetask");
export function l(str : "filetype_exchangetask");
export function l(str : "exchangeperson");
export function l(str : "filetype_exchangeperson");
export function l(str : "activedirperson");
export function l(str : "filetype_activedirperson");
export function l(str : "exchangeactivity");
export function l(str : "filetype_exchangeactivity");
export function l(str : "exchangecalendarmessage");
export function l(str : "filetype_exchangecalendarmessage");
export function l(str : "exchangedocument");
export function l(str : "filetype_exchangedocument");
export function l(str : "exchangedsn");
export function l(str : "filetype_exchangedsn");
export function l(str : "exchangefreebusy");
export function l(str : "filetype_exchangefreebusy");
export function l(str : "exchangegroup");
export function l(str : "filetype_exchangegroup");
export function l(str : "exchangerssfeed");
export function l(str : "filetype_exchangerssfeed");
export function l(str : "exchangejunkmessage");
export function l(str : "filetype_exchangejunkmessage");
export function l(str : "exchangeofficecom");
export function l(str : "filetype_exchangeofficecom");
export function l(str : "lithiummessage");
export function l(str : "filetype_lithiummessage");
export function l(str : "lithiumthread");
export function l(str : "filetype_lithiumthread");
export function l(str : "lithiumboard");
export function l(str : "filetype_lithiumboard");
export function l(str : "lithiumcategory");
export function l(str : "filetype_lithiumcategory");
export function l(str : "lithiumcommunity");
export function l(str : "filetype_lithiumcommunity");
export function l(str : "people");
export function l(str : "objecttype_people");
export function l(str : "message");
export function l(str : "objecttype_message");
export function l(str : "feed");
export function l(str : "objecttype_feed");
export function l(str : "thread");
export function l(str : "objecttype_thread");
export function l(str : "file");
export function l(str : "objecttype_file");
export function l(str : "board");
export function l(str : "objecttype_board");
export function l(str : "category");
export function l(str : "objecttype_category");
export function l(str : "account");
export function l(str : "objecttype_account");
export function l(str : "annotation");
export function l(str : "objecttype_annotation");
export function l(str : "campaign");
export function l(str : "objecttype_campaign");
export function l(str : "case");
export function l(str : "objecttype_case");
export function l(str : "contact");
export function l(str : "objecttype_contact");
export function l(str : "contract");
export function l(str : "objecttype_contract");
export function l(str : "event");
export function l(str : "objecttype_event");
export function l(str : "email");
export function l(str : "objecttype_email");
export function l(str : "goal");
export function l(str : "objecttype_goal");
export function l(str : "incident");
export function l(str : "objecttype_incident");
export function l(str : "invoice");
export function l(str : "objecttype_invoice");
export function l(str : "lead");
export function l(str : "objecttype_lead");
export function l(str : "list");
export function l(str : "objecttype_list");
export function l(str : "solution");
export function l(str : "objecttype_solution");
export function l(str : "report");
export function l(str : "objecttype_report");
export function l(str : "task");
export function l(str : "objecttype_task");
export function l(str : "user");
export function l(str : "objecttype_user");
export function l(str : "attachment");
export function l(str : "objecttype_attachment");
export function l(str : "casecomment");
export function l(str : "objecttype_casecomment");
export function l(str : "opportunity");
export function l(str : "objecttype_opportunity");
export function l(str : "opportunityproduct");
export function l(str : "objecttype_opportunityproduct");
export function l(str : "feeditem");
export function l(str : "objecttype_feeditem");
export function l(str : "feedcomment");
export function l(str : "objecttype_feedcomment");
export function l(str : "note");
export function l(str : "objecttype_note");
export function l(str : "product");
export function l(str : "objecttype_product");
export function l(str : "partner");
export function l(str : "objecttype_partner");
export function l(str : "queueitem");
export function l(str : "objecttype_queueitem");
export function l(str : "quote");
export function l(str : "objecttype_quote");
export function l(str : "salesliterature");
export function l(str : "objecttype_salesliterature");
export function l(str : "salesorder");
export function l(str : "objecttype_salesorder");
export function l(str : "service");
export function l(str : "objecttype_service");
export function l(str : "socialprofile");
export function l(str : "objecttype_socialprofile");
export function l(str : "kbdocumentation");
export function l(str : "objecttype_kbdocumentation");
export function l(str : "kbtechnicalarticle");
export function l(str : "objecttype_kbtechnicalarticle");
export function l(str : "kbsolution");
export function l(str : "objecttype_kbsolution");
export function l(str : "kbknowledgearticle");
export function l(str : "objecttype_kbknowledgearticle");
export function l(str : "kbattachment");
export function l(str : "objecttype_kbattachment");
export function l(str : "kbarticle");
export function l(str : "objecttype_kbarticle");
export function l(str : "kbarticlecomment");
export function l(str : "objecttype_kbarticlecomment");
export function l(str : "knowledgearticle");
export function l(str : "objecttype_knowledgearticle");
export function l(str : "topic");
export function l(str : "objecttype_topic");
export function l(str : "dashboard");
export function l(str : "objecttype_dashboard");
export function l(str : "contentversion");
export function l(str : "objecttype_contentversion");
export function l(str : "collaborationgroup");
export function l(str : "objecttype_collaborationgroup");
export function l(str : "phonecall");
export function l(str : "objecttype_phonecall");
export function l(str : "appointment");
export function l(str : "objecttype_appointment");
export function l(str : "sn_hr_core_case");
export function l(str : "filetype_sn_hr_core_case");
export function l(str : "sc_cat_item");
export function l(str : "filetype_sc_cat_item");
export function l(str : "sn_customerservice_case");
export function l(str : "filetype_sn_customerservice_case");
export function l(str : "kb_social_qa_answer");
export function l(str : "filetype_kb_social_qa_answer");
export function l(str : "kb_social_qa_question");
export function l(str : "filetype_kb_social_qa_question");
export function l(str : "kb_social_qa_comment");
export function l(str : "filetype_kb_social_qa_comment");
export function l(str : "filetype_incident");
export function l(str : "kb_knowledge");
export function l(str : "filetype_kb_knowledge");
export function l(str : "slackmessage");
export function l(str : "filetype_slackmessage");
export function l(str : "slackchannel");
export function l(str : "filetype_slackchannel");
export function l(str : "slackfile");
export function l(str : "filetype_slackfile");
export function l(str : "slackuser");
export function l(str : "filetype_slackuser");
export function l(str : "youtubevideo");
export function l(str : "filetype_youtubevideo");
export function l(str : "youtubeplaylistitem");
export function l(str : "filetype_youtubeplaylistitem");
export function l(str : "youtubeplaylist");
export function l(str : "filetype_youtubeplaylist");
export function l(str : "spportal");
export function l(str : "filetype_spportal");
export function l(str : "spsite");
export function l(str : "filetype_spsite");
export function l(str : "spuserprofile");
export function l(str : "filetype_spuserprofile");
export function l(str : "sparea");
export function l(str : "filetype_sparea");
export function l(str : "spannouncement");
export function l(str : "filetype_spannouncement");
export function l(str : "spannouncementlist");
export function l(str : "filetype_spannouncementlist");
export function l(str : "spcontact");
export function l(str : "filetype_spcontact");
export function l(str : "spcontactlist");
export function l(str : "filetype_spcontactlist");
export function l(str : "spcustomlist");
export function l(str : "filetype_spcustomlist");
export function l(str : "spdiscussionboard");
export function l(str : "filetype_spdiscussionboard");
export function l(str : "spdiscussionboardlist");
export function l(str : "filetype_spdiscussionboardlist");
export function l(str : "spdocumentlibrarylist");
export function l(str : "filetype_spdocumentlibrarylist");
export function l(str : "spevent");
export function l(str : "filetype_spevent");
export function l(str : "speventlist");
export function l(str : "filetype_speventlist");
export function l(str : "spformlibrarylist");
export function l(str : "filetype_spformlibrarylist");
export function l(str : "spissue");
export function l(str : "filetype_spissue");
export function l(str : "spissuelist");
export function l(str : "filetype_spissuelist");
export function l(str : "splink");
export function l(str : "filetype_splink");
export function l(str : "splinklist");
export function l(str : "filetype_splinklist");
export function l(str : "sppicturelibrarylist");
export function l(str : "filetype_sppicturelibrarylist");
export function l(str : "spsurvey");
export function l(str : "filetype_spsurvey");
export function l(str : "spsurveylist");
export function l(str : "filetype_spsurveylist");
export function l(str : "sptask");
export function l(str : "filetype_sptask");
export function l(str : "sptasklist");
export function l(str : "filetype_sptasklist");
export function l(str : "spagenda");
export function l(str : "filetype_spagenda");
export function l(str : "spagendalist");
export function l(str : "filetype_spagendalist");
export function l(str : "spattendee");
export function l(str : "filetype_spattendee");
export function l(str : "spattendeelist");
export function l(str : "filetype_spattendeelist");
export function l(str : "spcustomgridlist");
export function l(str : "filetype_spcustomgridlist");
export function l(str : "spdecision");
export function l(str : "filetype_spdecision");
export function l(str : "spdecisionlist");
export function l(str : "filetype_spdecisionlist");
export function l(str : "spobjective");
export function l(str : "filetype_spobjective");
export function l(str : "spobjectivelist");
export function l(str : "filetype_spobjectivelist");
export function l(str : "sptextbox");
export function l(str : "filetype_sptextbox");
export function l(str : "sptextboxlist");
export function l(str : "filetype_sptextboxlist");
export function l(str : "spthingstobring");
export function l(str : "filetype_spthingstobring");
export function l(str : "spthingstobringlist");
export function l(str : "filetype_spthingstobringlist");
export function l(str : "sparealisting");
export function l(str : "filetype_sparealisting");
export function l(str : "spmeetingserie");
export function l(str : "filetype_spmeetingserie");
export function l(str : "spmeetingserielist");
export function l(str : "filetype_spmeetingserielist");
export function l(str : "spsitedirectory");
export function l(str : "filetype_spsitedirectory");
export function l(str : "spsitedirectorylist");
export function l(str : "filetype_spsitedirectorylist");
export function l(str : "spdatasource");
export function l(str : "filetype_spdatasource");
export function l(str : "spdatasourcelist");
export function l(str : "filetype_spdatasourcelist");
export function l(str : "splisttemplatecataloglist");
export function l(str : "filetype_splisttemplatecataloglist");
export function l(str : "spwebpartcataloglist");
export function l(str : "filetype_spwebpartcataloglist");
export function l(str : "spwebtemplatecataloglist");
export function l(str : "filetype_spwebtemplatecataloglist");
export function l(str : "spworkspacepagelist");
export function l(str : "filetype_spworkspacepagelist");
export function l(str : "spunknownlist");
export function l(str : "filetype_spunknownlist");
export function l(str : "spadministratortask");
export function l(str : "filetype_spadministratortask");
export function l(str : "spadministratortasklist");
export function l(str : "filetype_spadministratortasklist");
export function l(str : "spareadocumentlibrarylist");
export function l(str : "filetype_spareadocumentlibrarylist");
export function l(str : "spblogcategory");
export function l(str : "filetype_spblogcategory");
export function l(str : "spblogcategorylist");
export function l(str : "filetype_spblogcategorylist");
export function l(str : "spblogcomment");
export function l(str : "filetype_spblogcomment");
export function l(str : "spblogcommentlist");
export function l(str : "filetype_spblogcommentlist");
export function l(str : "spblogpost");
export function l(str : "filetype_spblogpost");
export function l(str : "spblogpostlist");
export function l(str : "filetype_spblogpostlist");
export function l(str : "spdataconnectionlibrarylist");
export function l(str : "filetype_spdataconnectionlibrarylist");
export function l(str : "spdistributiongroup");
export function l(str : "filetype_spdistributiongroup");
export function l(str : "spdistributiongrouplist");
export function l(str : "filetype_spdistributiongrouplist");
export function l(str : "spipfslist");
export function l(str : "filetype_spipfslist");
export function l(str : "spkeyperformanceindicator");
export function l(str : "filetype_spkeyperformanceindicator");
export function l(str : "spkeyperformanceindicatorlist");
export function l(str : "filetype_spkeyperformanceindicatorlist");
export function l(str : "splanguagesandtranslator");
export function l(str : "filetype_splanguagesandtranslator");
export function l(str : "splanguagesandtranslatorlist");
export function l(str : "filetype_splanguagesandtranslatorlist");
export function l(str : "spmasterpagescataloglist");
export function l(str : "filetype_spmasterpagescataloglist");
export function l(str : "spnocodeworkflowlibrarylist");
export function l(str : "filetype_spnocodeworkflowlibrarylist");
export function l(str : "spprojecttask");
export function l(str : "filetype_spprojecttask");
export function l(str : "spprojecttasklist");
export function l(str : "filetype_spprojecttasklist");
export function l(str : "sppublishingpageslibrarylist");
export function l(str : "filetype_sppublishingpageslibrarylist");
export function l(str : "spreportdocumentlibrarylist");
export function l(str : "filetype_spreportdocumentlibrarylist");
export function l(str : "spreportlibrarylist");
export function l(str : "filetype_spreportlibrarylist");
export function l(str : "spslidelibrarylist");
export function l(str : "filetype_spslidelibrarylist");
export function l(str : "sptab");
export function l(str : "filetype_sptab");
export function l(str : "sptablist");
export function l(str : "filetype_sptablist");
export function l(str : "sptranslationmanagementlibrarylist");
export function l(str : "filetype_sptranslationmanagementlibrarylist");
export function l(str : "spuserinformation");
export function l(str : "filetype_spuserinformation");
export function l(str : "spuserinformationlist");
export function l(str : "filetype_spuserinformationlist");
export function l(str : "spwikipagelibrarylist");
export function l(str : "filetype_spwikipagelibrarylist");
export function l(str : "spworkflowhistory");
export function l(str : "filetype_spworkflowhistory");
export function l(str : "spworkflowhistorylist");
export function l(str : "filetype_spworkflowhistorylist");
export function l(str : "spworkflowprocess");
export function l(str : "filetype_spworkflowprocess");
export function l(str : "spworkflowprocesslist");
export function l(str : "filetype_spworkflowprocesslist");
export function l(str : "sppublishingimageslibrarylist");
export function l(str : "filetype_sppublishingimageslibrarylist");
export function l(str : "spcirculation");
export function l(str : "filetype_spcirculation");
export function l(str : "spcirculationlist");
export function l(str : "filetype_spcirculationlist");
export function l(str : "spdashboardslibrarylist");
export function l(str : "filetype_spdashboardslibrarylist");
export function l(str : "spdataconnectionforperformancepointlibrarylist");
export function l(str : "filetype_spdataconnectionforperformancepointlibrarylist");
export function l(str : "sphealthreport");
export function l(str : "filetype_sphealthreport");
export function l(str : "sphealthreportlist");
export function l(str : "filetype_sphealthreportlist");
export function l(str : "sphealthrule");
export function l(str : "filetype_sphealthrule");
export function l(str : "sphealthrulelist");
export function l(str : "filetype_sphealthrulelist");
export function l(str : "spimedictionary");
export function l(str : "filetype_spimedictionary");
export function l(str : "spimedictionarylist");
export function l(str : "filetype_spimedictionarylist");
export function l(str : "spperformancepointcontent");
export function l(str : "filetype_spperformancepointcontent");
export function l(str : "spperformancepointcontentlist");
export function l(str : "filetype_spperformancepointcontentlist");
export function l(str : "spphonecallmemo");
export function l(str : "filetype_spphonecallmemo");
export function l(str : "spphonecallmemolist");
export function l(str : "filetype_spphonecallmemolist");
export function l(str : "sprecordlibrarylist");
export function l(str : "filetype_sprecordlibrarylist");
export function l(str : "spresource");
export function l(str : "filetype_spresource");
export function l(str : "spresourcelist");
export function l(str : "filetype_spresourcelist");
export function l(str : "spprocessdiagramslibrarylist");
export function l(str : "filetype_spprocessdiagramslibrarylist");
export function l(str : "spsitethemeslibrarylist");
export function l(str : "filetype_spsitethemeslibrarylist");
export function l(str : "spsolutionslibrarylist");
export function l(str : "filetype_spsolutionslibrarylist");
export function l(str : "spwfpublibrarylist");
export function l(str : "filetype_spwfpublibrarylist");
export function l(str : "spwhereabout");
export function l(str : "filetype_spwhereabout");
export function l(str : "spwhereaboutlist");
export function l(str : "filetype_spwhereaboutlist");
export function l(str : "spdocumentlink");
export function l(str : "filetype_spdocumentlink");
export function l(str : "spdocumentset");
export function l(str : "filetype_spdocumentset");
export function l(str : "spmicrofeedpost");
export function l(str : "filetype_spmicrofeedpost");
export function l(str : "spmicrofeedlist");
export function l(str : "filetype_spmicrofeedlist");
export function l(str : "splistfolder");
export function l(str : "filetype_splistfolder");
export function l(str : "Unknown");
export function l(str : "And");
export function l(str : "Authenticating" , param0: string);
export function l(str : "Clear" , param0: string);
export function l(str : "CompleteQuery");
export function l(str : "Exclude" , param0: string);
export function l(str : "EnterTag");
export function l(str : "Next");
export function l(str : "Last");
export function l(str : "Link");
export function l(str : "Or");
export function l(str : "Previous");
export function l(str : "QueryDidntMatchAnyDocuments");
export function l(str : "QueryException" , param0: string);
export function l(str : "Me");
export function l(str : "Remove");
export function l(str : "Search");
export function l(str : "SearchFor" , param0: string);
export function l(str : "SubmitSearch");
export function l(str : "ShareQuery");
export function l(str : "Preferences");
export function l(str : "LinkOpeningSettings");
export function l(str : "Reauthenticate" , param0: string);
export function l(str : "ResultsFilteringExpression");
export function l(str : "FiltersInYourPreferences");
export function l(str : "Create");
export function l(str : "SearchIn" , param0: string);
export function l(str : "Seconds" , param0: string, count: number);
export function l(str : "ShowingResultsOf" , param0: string, param1: string, param2: string, count: number);
export function l(str : "ShowingResultsOfWithQuery" , param0: string, param1: string, param2: string, param3: string, count: number);
export function l(str : "SwitchTo" , param0: string);
export function l(str : "Unexclude" , param0: string);
export function l(str : "ClearAllFilters");
export function l(str : "SkipLogin");
export function l(str : "LoginInProgress");
export function l(str : "Login");
export function l(str : "GetStarted");
export function l(str : "More");
export function l(str : "NMore" , param0: string);
export function l(str : "Less");
export function l(str : "Settings");
export function l(str : "Score");
export function l(str : "ScoreDescription");
export function l(str : "Occurrences");
export function l(str : "OccurrencesDescription");
export function l(str : "Label");
export function l(str : "Of");
export function l(str : "LabelDescription");
export function l(str : "Value");
export function l(str : "ValueDescription");
export function l(str : "AlphaAscending");
export function l(str : "AlphaDescending");
export function l(str : "ChiSquare");
export function l(str : "Nosort");
export function l(str : "NosortDescription");
export function l(str : "RelativeFrequency");
export function l(str : "RelativeFrequencyDescription");
export function l(str : "DateDistribution");
export function l(str : "Custom");
export function l(str : "CustomDescription");
export function l(str : "ComputedField");
export function l(str : "Ascending");
export function l(str : "Descending");
export function l(str : "noResultFor" , param0: string);
export function l(str : "noResult");
export function l(str : "autoCorrectedQueryTo" , param0: string);
export function l(str : "didYouMean" , param0: string);
export function l(str : "SuggestedResults");
export function l(str : "SuggestedQueries");
export function l(str : "MostRelevantItems");
export function l(str : "AllItems");
export function l(str : "ShowLess");
export function l(str : "ShowMore");
export function l(str : "HideFacet");
export function l(str : "ShowFacet");
export function l(str : "AndOthers" , param0: string, count: number);
export function l(str : "Others" , param0: string, count: number);
export function l(str : "MostRelevantPosts");
export function l(str : "CompleteThread");
export function l(str : "ShowCompleteThread");
export function l(str : "ShowOnlyTopMatchingPosts");
export function l(str : "MostRelevantReplies");
export function l(str : "AllConversation");
export function l(str : "ShowAllConversation");
export function l(str : "ShowAllReplies");
export function l(str : "ShowOnlyMostRelevantReplies");
export function l(str : "Close");
export function l(str : "Open");
export function l(str : "OpenInOutlookWhenPossible");
export function l(str : "AlwaysOpenInNewWindow");
export function l(str : "Quickview");
export function l(str : "NoQuickview");
export function l(str : "ErrorReport");
export function l(str : "OopsError");
export function l(str : "ProblemPersists");
export function l(str : "GoBack");
export function l(str : "Reset");
export function l(str : "Retry");
export function l(str : "MoreInfo");
export function l(str : "Username");
export function l(str : "Password");
export function l(str : "PostedBy");
export function l(str : "CannotConnect");
export function l(str : "BadUserPass");
export function l(str : "PleaseEnterYourCredentials" , param0: string);
export function l(str : "PleaseEnterYourSearchPage");
export function l(str : "Collapse");
export function l(str : "Collapsable");
export function l(str : "Expand");
export function l(str : "CollapseFacet" , param0: string);
export function l(str : "ExpandFacet" , param0: string);
export function l(str : "ShowLessFacetResults" , param0: string);
export function l(str : "ShowMoreFacetResults" , param0: string);
export function l(str : "ShowLessCategoryResults" , param0: string);
export function l(str : "ShowMoreCategoryResults" , param0: string);
export function l(str : "ShowLessHierarchicalResults" , param0: string);
export function l(str : "ShowMoreHierarchicalResults" , param0: string);
export function l(str : "SearchFacetResults" , param0: string);
export function l(str : "Today");
export function l(str : "Yesterday");
export function l(str : "Tomorrow");
export function l(str : "Duration" , param0: string);
export function l(str : "IndexDuration" , param0: string);
export function l(str : "ProxyDuration" , param0: string);
export function l(str : "ClientDuration" , param0: string);
export function l(str : "Unavailable");
export function l(str : "Reply");
export function l(str : "ReplyAll");
export function l(str : "Forward");
export function l(str : "From");
export function l(str : "Caption");
export function l(str : "Expression");
export function l(str : "Tab");
export function l(str : "Tabs");
export function l(str : "EnterExpressionName");
export function l(str : "EnterExpressionToFilterWith");
export function l(str : "SelectTab");
export function l(str : "SelectAll");
export function l(str : "PageUrl");
export function l(str : "ErrorSavingToDevice");
export function l(str : "ErrorReadingFromDevice");
export function l(str : "AppIntro");
export function l(str : "TryDemo");
export function l(str : "ContactUs");
export function l(str : "NewToCoveo");
export function l(str : "LetUsHelpGetStarted");
export function l(str : "LikesThis" , param0: string, count: number);
export function l(str : "CannotConnectSearchPage");
export function l(str : "AreYouSureDeleteFilter" , param0: string, param1: string);
export function l(str : "OnlineHelp");
export function l(str : "Done");
export function l(str : "SaveFacetState");
export function l(str : "ClearFacetState");
export function l(str : "DisplayingTheOnlyMessage");
export function l(str : "NoNetworkConnection");
export function l(str : "UnknownConnection");
export function l(str : "EthernetConnection");
export function l(str : "WiFi");
export function l(str : "CELL");
export function l(str : "CELL_2G");
export function l(str : "CELL_3G");
export function l(str : "CELL_4G");
export function l(str : "Relevance");
export function l(str : "Date");
export function l(str : "Amount");
export function l(str : "QueryExceptionNoException");
export function l(str : "QueryExceptionInvalidSyntax");
export function l(str : "QueryExceptionInvalidCustomField");
export function l(str : "QueryExceptionInvalidDate");
export function l(str : "QueryExceptionInvalidExactPhrase");
export function l(str : "QueryExceptionInvalidDateOp");
export function l(str : "QueryExceptionInvalidNear");
export function l(str : "QueryExceptionInvalidWeightedNear");
export function l(str : "QueryExceptionInvalidTerm");
export function l(str : "QueryExceptionTooManyTerms");
export function l(str : "QueryExceptionWildcardTooGeneral");
export function l(str : "QueryExceptionInvalidSortField");
export function l(str : "QueryExceptionInvalidSmallStringOp");
export function l(str : "QueryExceptionRequestedResultsMax");
export function l(str : "QueryExceptionAggregatedMirrorDead");
export function l(str : "QueryExceptionAggregatedMirrorQueryTimeOut");
export function l(str : "QueryExceptionAggregatedMirrorInvalidBuildNumber");
export function l(str : "QueryExceptionAggregatedMirrorCannotConnect");
export function l(str : "QueryExceptionNotEnoughLeadingCharsWildcard");
export function l(str : "QueryExceptionSecurityInverterNotFound");
export function l(str : "QueryExceptionSecurityInverterAccessDenied");
export function l(str : "QueryExceptionAggregatedMirrorCannotImpersonate");
export function l(str : "QueryExceptionUnexpected");
export function l(str : "QueryExceptionAccessDenied");
export function l(str : "QueryExceptionSuperUserTokenInvalid");
export function l(str : "QueryExceptionSuperUserTokenExpired");
export function l(str : "QueryExceptionLicenseQueriesExpired");
export function l(str : "QueryExceptionLicenseSuperUserTokenNotSupported");
export function l(str : "QueryExceptionInvalidSession");
export function l(str : "QueryExceptionInvalidDocument");
export function l(str : "QueryExceptionSearchDisabled");
export function l(str : "FileType");
export function l(str : "ShowAttachment");
export function l(str : "OnFeed" , param0: string);
export function l(str : "Author");
export function l(str : "NoTitle");
export function l(str : "CurrentSelections");
export function l(str : "AllContent");
export function l(str : "CancelLastAction");
export function l(str : "SearchTips");
export function l(str : "CheckSpelling");
export function l(str : "TryUsingFewerKeywords");
export function l(str : "SelectFewerFilters");
export function l(str : "Document");
export function l(str : "Time");
export function l(str : "StartDate");
export function l(str : "StartTime");
export function l(str : "DurationTitle");
export function l(str : "UserQuery");
export function l(str : "ShowUserActions");
export function l(str : "NoData");
export function l(str : "EventType");
export function l(str : "GoToFullSearch");
export function l(str : "GoToEdition");
export function l(str : "RemoveContext");
export function l(str : "BoxAttachToCase");
export function l(str : "AttachToCase");
export function l(str : "Attach");
export function l(str : "Attached");
export function l(str : "Detach");
export function l(str : "Details");
export function l(str : "AdditionalFilters");
export function l(str : "SelectNonContextualSearch");
export function l(str : "CopyPasteToSupport");
export function l(str : "FollowQueryDescription");
export function l(str : "SearchAlerts_Panel");
export function l(str : "SearchAlerts_PanelDescription");
export function l(str : "SearchAlerts_PanelNoSearchAlerts");
export function l(str : "SearchAlerts_Fail");
export function l(str : "SearchAlerts_Type");
export function l(str : "SearchAlerts_Content");
export function l(str : "SearchAlerts_Actions");
export function l(str : "EmptyQuery");
export function l(str : "SearchAlerts_Type_followQuery");
export function l(str : "SearchAlerts_Type_followDocument");
export function l(str : "SearchAlerts_unFollowing");
export function l(str : "SearchAlerts_follow");
export function l(str : "SearchAlerts_followed");
export function l(str : "SearchAlerts_followQuery");
export function l(str : "Subscription_StopFollowingQuery");
export function l(str : "SearchAlerts_Frequency");
export function l(str : "SubscriptionsManageSubscriptions");
export function l(str : "SubscriptionsMessageFollowQuery" , param0: string);
export function l(str : "SubscriptionsMessageFollow" , param0: string);
export function l(str : "Expiration");
export function l(str : "Monthly");
export function l(str : "Daily");
export function l(str : "Monday");
export function l(str : "Tuesday");
export function l(str : "Wednesday");
export function l(str : "Thursday");
export function l(str : "Friday");
export function l(str : "Saturday");
export function l(str : "Sunday");
export function l(str : "NextDay" , param0: string);
export function l(str : "LastDay" , param0: string);
export function l(str : "StartTypingCaseForSuggestions");
export function l(str : "ExportToExcel");
export function l(str : "ExportToExcelDescription");
export function l(str : "CaseCreationNoResults");
export function l(str : "SortBy");
export function l(str : "BoxCreateArticle");
export function l(str : "Facets");
export function l(str : "AdvancedSearch");
export function l(str : "Keywords");
export function l(str : "AllTheseWords");
export function l(str : "ExactPhrase");
export function l(str : "AnyOfTheseWords");
export function l(str : "NoneOfTheseWords");
export function l(str : "Anytime");
export function l(str : "InTheLast");
export function l(str : "Days");
export function l(str : "Months");
export function l(str : "Month");
export function l(str : "Year");
export function l(str : "Between");
export function l(str : "Language");
export function l(str : "Size");
export function l(str : "AtLeast");
export function l(str : "AtMost");
export function l(str : "Contains");
export function l(str : "DoesNotContain");
export function l(str : "Matches");
export function l(str : "Bytes");
export function l(str : "card");
export function l(str : "table");
export function l(str : "ResultLinks");
export function l(str : "EnableQuerySyntax");
export function l(str : "On");
export function l(str : "Off");
export function l(str : "Automatic");
export function l(str : "ResultsPerPage");
export function l(str : "PreviousMonth");
export function l(str : "NextMonth");
export function l(str : "Title");
export function l(str : "FiltersInAdvancedSearch");
export function l(str : "NoEndpoints" , param0: string);
export function l(str : "InvalidToken");
export function l(str : "AddSources");
export function l(str : "TryAgain");
export function l(str : "CoveoOnlineHelp");
export function l(str : "CannotAccess" , param0: string);
export function l(str : "CoveoOrganization");
export function l(str : "SearchAPIDuration" , param0: string);
export function l(str : "LastUpdated");
export function l(str : "AllDates");
export function l(str : "WithinLastDay");
export function l(str : "WithinLastWeek");
export function l(str : "WithinLastMonth");
export function l(str : "WithinLastYear");
export function l(str : "RelevanceInspector");
export function l(str : "KeywordInCategory" , param0: string, param1: string);
export function l(str : "Result");
export function l(str : "ResultCount" , param0: string, count: number);
export function l(str : "ShowingResults" , param0: string, count: number);
export function l(str : "ShowingResultsWithQuery" , param0: string, param1: string, count: number);
export function l(str : "NumberOfVideos");
export function l(str : "AllCategories");
export function l(str : "Recommended");
export function l(str : "Featured");
export function l(str : "CoveoHomePage");
export function l(str : "SizeValue");
export function l(str : "UnitMeasurement");
export function l(str : "Toggle");
export function l(str : "FilterOn" , param0: string);
export function l(str : "RemoveFilterOn" , param0: string);
export function l(str : "Enter");
export function l(str : "InsertAQuery");
export function l(str : "PressEnterToSend");
export function l(str : "SortResultsBy" , param0: string);
export function l(str : "SortResultsByAscending" , param0: string);
export function l(str : "SortResultsByDescending" , param0: string);
export function l(str : "DisplayResultsAs" , param0: string);
export function l(str : "FacetTitle" , param0: string);
export function l(str : "IncludeValueWithResultCount" , param0: string, param1: string);
export function l(str : "ExcludeValueWithResultCount" , param0: string, param1: string);
export function l(str : "PageNumber" , param0: string);
export function l(str : "DisplayResultsPerPage" , param0: string);
export function l(str : "GroupByAndFacetRequestsCannotCoexist");
export function l(str : "MustContain");
export function l(str : "Missing");
export function l(str : "Filters");
export function l(str : "FiltersDropdown");
export function l(str : "OpenFiltersDropdown");
export function l(str : "CloseFiltersDropdown");
export function l(str : "NoValuesFound");
export function l(str : "To");
export function l(str : "DeselectFilterValues" , param0: string);
export function l(str : "Rated" , param0: string, param1: string, count: number);
export function l(str : "RatedBy" , param0: string, count: number);
export function l(str : "NoRatings");
export function l(str : "Pagination");
export function l(str : "ThumbnailOf" , param0: string);
export function l(str : "CollapsedUriParts");
export function l(str : "HierarchicalFacetValueIndentedUnder" , param0: string, param1: string);
export function l(str : "HierarchicalFacetValuePathPrefix");
export function l(str : "UsefulnessFeedbackRequest");
export function l(str : "UsefulnessFeedbackThankYou");
export function l(str : "UsefulnessFeedbackExplainWhy");
export function l(str : "UsefulnessFeedbackExplainWhyImperative");
export function l(str : "UsefulnessFeedbackDoesNotAnswer");
export function l(str : "UsefulnessFeedbackPartiallyAnswers");
export function l(str : "UsefulnessFeedbackWasNotAQuestion");
export function l(str : "Yes");
export function l(str : "No");
export function l(str : "Other");
export function l(str : "Send");
export function l(str : "Edit");
export function l(str : "Delete");
export function l(str : "Save");
export function l(str : "UsefulnessFeedbackReason");
export function l(str : "AnswerSnippet");
export function l(str : "AnswerSpecificSnippet" , param0: string);
export function l(str : "SuggestedQuestions");
export function l(str : "ExpandQuestionAnswer" , param0: string);
export function l(str : "MoreValuesAvailable");
export function l(str : "Breadcrumb");
export function l(str : "OrganizationIsPaused");
export function l(str : "OrganizationWillResume");
export function l(str : "UpdatingResults");
export function l(str : "QuerySuggestionsAvailable" , param0: string, count: number);
export function l(str : "QuerySuggestionsUnavailable");
export function l(...params : any[]);
export function l(...params : any[]) { return L10N.format.apply(this, arguments) };



// WEBPACK FOOTER //
// ./src/strings/Strings.ts